var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.3333C13.5 10.6575 13.3712 10.9684 13.142 11.1976C12.9128 11.4268 12.6019 11.5556 12.2778 11.5556H4.94444L2.5 14V4.22222C2.5 3.89807 2.62877 3.58719 2.85798 3.35798C3.08719 3.12877 3.39807 3 3.72222 3H12.2778C12.6019 3 12.9128 3.12877 13.142 3.35798C13.3712 3.58719 13.5 3.89807 13.5 4.22222V10.3333Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.b4edaedc6dbda4760d9faf78ed1131ea.svg";
export { ForwardRef as ReactComponent };